import { render, staticRenderFns } from "./RetrievePasswordModal.vue?vue&type=template&id=05615bff&scoped=true"
import script from "./RetrievePasswordModal.vue?vue&type=script&lang=js"
export * from "./RetrievePasswordModal.vue?vue&type=script&lang=js"
import style0 from "./RetrievePasswordModal.vue?vue&type=style&index=0&id=05615bff&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05615bff",
  null
  
)

export default component.exports